import { Deserializable } from '../protocols/deserializable';

export class MemberSubmissionAccount implements Deserializable {
  public accountId!: number;
  public employerName!: string;
  public annuityType?: string;

  public onDeserialize(): void {}
}
